// File: src/i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

const resources = {
  vi: {
    translation: {
      // --- NAVBAR & MENU ---
      "jobs": "Việc làm",
      "companies": "Công ty",
      "tests": "Bài Test",
      "blog": "Blog",
      "login": "Đăng nhập",
      "register_business": "Nhà tuyển dụng",
      
      // --- BUSINESS MENU ---
      "dashboard": "Tổng quan",
      "recruitment": "Tuyển dụng",
      "candidates": "Ứng viên",
      "test_bank": "Kho Test",
      "manage_recruitment": "Quản lý tuyển dụng",
      "posted_jobs": "Tin tuyển dụng đã đăng",
      "candidate_profiles": "Hồ sơ ứng viên",
      
      // --- CANDIDATE MENU ---
      "manage_profile": "Quản lý hồ sơ",
      "saved_jobs": "Việc làm đã lưu",
      "test_history": "Bài test đã làm",
      "following_companies": "Công ty đã theo dõi",
      "mock_interview": "Phỏng vấn thử AI",
      "interview_schedule": "Lịch phỏng vấn",
      "who_viewed_me": "Người đã xem hồ sơ",

      // --- ACCOUNT & SETTINGS ---
      "account_settings": "Tài khoản & Cài đặt",
      "upgrade_vip": "Nâng cấp tài khoản VIP",
      "upgrade_business": "Nâng cấp Gói Doanh nghiệp",
      "change_password": "Đổi mật khẩu",
      "logout": "Đăng xuất",
      "verified_account": "Tài khoản xác thực",

      // --- UPGRADE PAGE (Gói cước) ---
      "candidate_pkg": "Gói Ứng Viên",
      "business_pkg": "Gói Doanh Nghiệp",
      "current_plan": "Đang sử dụng",
      "days_left": "Còn {{count}} ngày",
      "expired_at": "Hết hạn: {{date}}",
      "wait_expire": "Chờ hết hạn",
      "upgrade_now": "Nâng Cấp Ngay",
      "register_now": "Đăng Ký Ngay",
      "loading": "Đang xử lý...",
      "secure_payment": "Thanh toán an toàn qua PayOS",
      "secure_desc": "Hệ thống bảo mật bởi PayOS (VietQR, Momo, Banking).",
      "trust_text": "Được tin dùng bởi các đối tác hàng đầu",
      
      "titles": {
        "candidate": "Bứt phá sự nghiệp với SkillMatch VIP",
        "candidate_sub": "Đầu tư cho tương lai với chi phí chỉ bằng một ly cà phê mỗi tháng.",
        "business": "Tuyển dụng nhân tài đỉnh cao",
        "business_sub": "Giải pháp tuyển dụng thông minh giúp tiết kiệm 80% thời gian sàng lọc."
      }
    }
  },
  en: {
    translation: {
      // --- NAVBAR & MENU ---
      "jobs": "Jobs",
      "companies": "Companies",
      "tests": "Tests",
      "blog": "Blog",
      "login": "Login",
      "register_business": "For Employers",

      // --- BUSINESS MENU ---
      "dashboard": "Dashboard",
      "recruitment": "Recruitment",
      "candidates": "Candidates",
      "test_bank": "Test Bank",
      "manage_recruitment": "Recruitment Management",
      "posted_jobs": "Posted Jobs",
      "candidate_profiles": "Candidate Profiles",

      // --- CANDIDATE MENU ---
      "manage_profile": "Profile Management",
      "saved_jobs": "Saved Jobs",
      "test_history": "Test History",
      "following_companies": "Following Companies",
      "mock_interview": "AI Mock Interview",
      "interview_schedule": "Interview Schedule",
      "who_viewed_me": "Who viewed my profile",

      // --- ACCOUNT & SETTINGS ---
      "account_settings": "Account & Settings",
      "upgrade_vip": "Upgrade VIP Account",
      "upgrade_business": "Upgrade Business Plan",
      "change_password": "Change Password",
      "logout": "Logout",
      "verified_account": "Verified Account",

      // --- UPGRADE PAGE ---
      "candidate_pkg": "Candidate Plan",
      "business_pkg": "Business Plan",
      "current_plan": "Current Plan",
      "days_left": "{{count}} days left",
      "expired_at": "Expires: {{date}}",
      "wait_expire": "Wait for expiry",
      "upgrade_now": "Upgrade Now",
      "register_now": "Register Now",
      "loading": "Processing...",
      "secure_payment": "Secure payment via PayOS",
      "secure_desc": "Secured by PayOS (VietQR, Momo, Banking).",
      "trust_text": "Trusted by top partners",

      "titles": {
        "candidate": "Boost your career with SkillMatch VIP",
        "candidate_sub": "Invest in your future for the cost of a coffee per month.",
        "business": "Hire top talents efficiently",
        "business_sub": "Smart recruitment solution saving 80% screening time."
      }
    }
  }
};

i18n
  .use(LanguageDetector) // Tự động phát hiện ngôn ngữ người dùng
  .use(initReactI18next) // Tích hợp với React
  .init({
    resources,
    lng: localStorage.getItem('i18nextLng') || "vi", // Ưu tiên lấy từ localStorage, nếu không có thì mặc định tiếng Việt
    fallbackLng: "vi",
    interpolation: {
      escapeValue: false // React đã tự xử lý XSS an toàn
    },
    detection: {
        order: ['localStorage', 'navigator'],
        caches: ['localStorage']
    }
  });

export default i18n;